(function () {

function initResourcesLibrary(root) {
  if (root.dataset.resourcesLibraryInitialized === 'true') return;

  const form = root.querySelector('#resources-filter-form');
  const resetButton = root.querySelector('#resources-filter-form-reset');
  const noResources = root.querySelector('#no-resources');
  const items = Array.from(root.querySelectorAll('.resource-item'));

  if (!form) return;

  root.dataset.resourcesLibraryInitialized = 'true';

  function getText(item, selector) {
    return item.querySelector(selector)?.textContent.toLowerCase() || '';
  }

  function filterResources() {
    const formData = new FormData(form);
    const category = formData.get('category') || 'all';
    const keyword = (formData.get('category-search-param') || '').trim().toLowerCase();
    let visibleCount = 0;

    items.forEach((item) => {
      const categories = (item.dataset.categories || '').split(',');
      const matchesCategory = category === 'all' || categories.includes(category);
      const matchesKeyword =
        !keyword ||
        getText(item, '.resource-item_details_title').includes(keyword) ||
        getText(item, '.resource-item_details_summary').includes(keyword);
      const isVisible = matchesCategory && matchesKeyword;

      item.hidden = !isVisible;
      if (isVisible) visibleCount += 1;
    });

    if (noResources) noResources.hidden = visibleCount > 0;
  }

  form.addEventListener('submit', (event) => {
    event.preventDefault();
    filterResources();
  });

  resetButton?.addEventListener('click', () => {
    form.reset();
    filterResources();
  });
}

function init() {
  document.querySelectorAll('[data-resources-library]').forEach(initResourcesLibrary);
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', init);
} else {
  init();
}

document.addEventListener('shopify:section:load', init);

})();
